import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpConfiguratorCartEntryInfoComponent} from './dcp-configurator-cart-entry-info.component';
import {ConfigureCartEntryModule} from '@spartacus/product-configurator/common';

@NgModule({
  declarations: [DcpConfiguratorCartEntryInfoComponent],
  imports: [CommonModule, ConfigureCartEntryModule],
  exports: [DcpConfiguratorCartEntryInfoComponent],
})
export class DcpConfiguratorCartEntryInfoModule {}
